import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import footer from './sections/footer';
import hero from './sections/hero';
import cols from './sections/columns';
// import spin from './sections/spin';
import casestudy from './pages/casestudy';
import _, { nth } from 'lodash';
// import quicklinks from './enhancements/quicklinks';
// import float from './sections/float';

import $ from "jquery";

init();
modalSection();
headerSection();
footer();
hero();
cols();
// spin();
casestudy();
// quicklinks();
// float();

let dots = document.querySelectorAll('.dot');
dots.forEach(dot => {
  dot.addEventListener('click', event => {
    dots.forEach(dot => {
      let box = dot.querySelector('.info');
      box.classList.add('hidden');
    });
    let box = event.currentTarget.querySelector('.info');
    box.classList.toggle('hidden');
  });
});

// Form radio clicks
const formieForm = document.querySelector('.formie-form');
if (formieForm) {
  let radios = formieForm.querySelectorAll('.fui-radio label');
  radios.forEach(radio => {
    radio.addEventListener('mouseup', event => {

      let wrap = radio.parentElement;
      let layout = wrap.parentElement;
      let siblings = layout.querySelectorAll('.fui-radio');

      siblings.forEach(r => {
        r.classList.remove('is-checked');
      });

      wrap.classList.toggle('is-checked');
    });
  });
}

// Animate Flash Headlines When In Viewport
let observed = false;
const flashContainers = document.querySelectorAll(".flash-container");

const flashContainesObserver = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    const trailContainers = entry.target.querySelectorAll('.trail');
   
    if (entry.isIntersecting) {
      trailContainers.forEach(trail => {
        trail.innerHTML = trail.nextElementSibling.innerHTML;
      });
      entry.target.classList.add('revealed');
      entry.target.classList.add('flash-position');
      setTimeout(function() {
        trailContainers.forEach(trail => {
          trail.innerHTML = '';
        });
      }, 3000);
    } else {
      if (observed) {
        entry.target.classList.remove('revealed');
        entry.target.classList.remove('flash-position');
      }
      observed = true;
    } 
  });
});
flashContainers.forEach(section => {
  flashContainesObserver.observe(section);
});


// Manifesto animation
document.querySelectorAll('main.generalPage.manifesto .text > h1').forEach(element => {

  // add spans
  element.innerHTML = `<span>${element.innerHTML.split('<br>').join(`</span><span>`)}</span>`;
  
  let lines = [];
  let index = 0;
  let hilightedLine = 0;
  element.querySelectorAll('span').forEach(line => { // intial states
    line.dataset.lineIndex = index;
    line.style.display = 'block';
    line.style.transition = 'all'
    line.style.transitionDuration = '480ms';
    line.style.paddingTop = '28px';
    line.style.opacity = 0;
    lines.push(line);
    index++;
  });

  setInterval(() => { // scan lines for intersection
    let screenMiddle = (window.innerHeight / 2) - 20; // slightly up from middle
    screenMiddle = screenMiddle > 525 ? 525 : screenMiddle; // limit it a bit
    index = 0;
    lines.forEach(line => {
      let top = line.getBoundingClientRect().top;
      let bottom = line.getBoundingClientRect().bottom;
      let intersects = top < screenMiddle && bottom > screenMiddle;
      if (intersects) {
        line.style.opacity = 1;
        hilightedLine = index; // the currently highlighted line
      } 
      if (hilightedLine != index) {
        let diff = Math.abs(Number(line.dataset.lineIndex) - hilightedLine);
        if (diff == 1) {
          line.style.opacity = (bottom < screenMiddle) ? 0.08 : 0.14; // lighter when above
          line.style.paddingTop = '0px';
        } else {
          line.style.opacity = 0;
          if (top > screenMiddle) {
            line.style.paddingTop = '20px';
          }
        }
      }
      index++;
    });
  }, 100); // check interval as scroll event can be intermittent
});

/** Immortal UTM Parameters */
(function() {
  const baseHref = document.getElementsByTagName('base')[0].href;
  const keys = [
     'gclid',
     'utm_source',
     'utm_medium',
     'utm_campaign',
     'utm_term',
     'utm_adgroup',
     'utm_content'
  ];
  let params = Object.fromEntries(new URLSearchParams(window.location.search));
  for (const key in params) if (params.hasOwnProperty(key)) {
     if (!keys.includes(key)) delete params[key];
  }
  if (Object.keys(params).length < 1) return; // nothing we want to keep so exit
  document.querySelectorAll('a').forEach(a => {
     let href = a.href;
     if (href.includes(baseHref)) {
        let hash = '';
        if (href.includes('#')) { // extract any hash value so that we can stick it on the end of the new url
           hash = href.match(/#[a-z]*/)[0];
           href = href.replace(hash, '');
        }
        let segments = href.split('?');
        params = !segments[1] ? params : Object.assign(Object.fromEntries(new URLSearchParams(segments[1])), params);
        a.href = `${segments[0]}?${new URLSearchParams(params).toString()}${hash}`;
     }
  });
})();

/* hubspot footer multi page form */

const footerHubspotForm = document.querySelector('footer .hbspt-form');

footerHubspotForm.classList.add('hs--subsribe-form');
const hForm = document.querySelector('footer .hs--subsribe-form');
window.addEventListener('load', function () {

setTimeout(() => {
const hForm = document.querySelector('footer .hs--subsribe-form');  
const sForm = hForm.querySelector('form');

if(sForm) {
const form = sForm;
const formEmail = sForm.querySelector('.hs_email');  

const fieldset1 = form.childNodes[0];
const fieldset2 = form.childNodes[1];
const fieldset3 = form.childNodes[2];

formEmail.insertAdjacentHTML('afterend', "<div class=\"hs-submit\"><div class=\"actions\"><button class=\"next hbs--btn\" type=\"button\">Next</button></div></div>");

const emailInput = fieldset1.querySelector('input');
const nextButton = sForm.querySelector('.hbs--btn.next');
const nextBtnContainer = nextButton.parentElement;

fieldset2.style.display = 'none';
fieldset3.style.display = 'none'; 

nextBtnContainer.style.opacity = '0';
nextBtnContainer.style.transition = 'opacity 0.3s ease-in-out';

emailInput.addEventListener('input', function() {
  if (emailInput.value.includes('@')) {
    nextButton.disabled = false;
    nextBtnContainer.style.opacity = '1';
  } else {
    nextButton.disabled = true;
    nextBtnContainer.style.opacity = '0';
  }
});

nextButton.addEventListener('click', function() {

  fieldset1.style.display = 'none';
  fieldset2.style.display = 'flex';
  fieldset2.classList.add('form-fade-in');
  fieldset3.style.display = 'block'; 
  fieldset3.classList.add('form-fade-in');
});

}

}, 500)

});


// WEBPACK FOOTER //
// ./source/scripts/main.js